/* eslint-disable */
/**
 * @note This is an auto-generated file. Do not modify it directly.
 * @see https://devdocs.transfix.io/graphql
 *
 * If you need to update the hooks or definitions in this file:
 * 1. Edit the .graphql file in this directory with the same name
 * 2. Run `npm run generate:graphql:mp` in the terminal
 */

import * as Types from '../../../../../../types/graphqlTypes'

import { gql } from '@apollo/client'
export type IEscalatedIssueFragment = { __typename?: 'ShipmentIssue' } & Pick<
  Types.IShipmentIssue,
  'id' | 'escalated' | 'notified' | 'shouldEscalate' | 'shouldNotify' | 'priority'
> & {
    type: { __typename?: 'ShipmentIssueType' } & Pick<Types.IShipmentIssueType, 'id' | 'name'> & {
        category?: Types.Maybe<
          { __typename?: 'ShipmentIssueCategory' } & Pick<
            Types.IShipmentIssueCategory,
            'id' | 'name'
          >
        >
      }
    shipment: { __typename?: 'Shipment' } & Pick<Types.IShipment, 'id' | 'shipperRateType'> & {
        shipperApplication: { __typename?: 'ShipperApplication' } & Pick<
          Types.IShipperApplication,
          'id' | 'name'
        >
        equipment: { __typename?: 'Equipment' } & Pick<
          Types.IEquipment,
          'id' | 'name' | 'parentKey'
        >
        characteristics: { __typename?: 'ShipmentCharacteristics' } & Pick<
          Types.IShipmentCharacteristics,
          | 'hazmat'
          | 'hot'
          | 'mustGo'
          | 'backhaulEligible'
          | 'rolloverCount'
          | 'sameDaySpot'
          | 'bounceCount'
        >
      }
  }

export const EscalatedIssueFragmentDoc = gql`
  fragment EscalatedIssue on ShipmentIssue {
    id
    escalated
    notified
    shouldEscalate
    shouldNotify
    type {
      id
      category {
        id
        name
      }
      name
    }
    priority
    shipment {
      id
      shipperRateType
      shipperApplication {
        id
        name
      }
      equipment {
        id
        name
        parentKey
      }
      characteristics {
        hazmat
        hot
        mustGo
        backhaulEligible
        rolloverCount
        sameDaySpot
        bounceCount
      }
    }
  }
`
